import React from 'react';
import GrayNavBar from './layout/gray-navbar';

const About = () =>
(
    <div>
        <GrayNavBar/>
        <div className="section about-pg">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                  <div className="about-box">
                      <h1 className="text-center reduce-margin">About Us</h1>

                      <h3>What we do and why?</h3>
                      <br/>
                      <p className="lead">
                          At FreshBytes, we develop cloud technology for Restaurants.<br/>
                          <br/>

                          There is a record growth in customers ordering online from their mobile. Most restaurants don’t offer the technology which allows their customers to order quickly from their mobile phone. If the technology exists, it is not as advanced so as to provide a good customer experience.

                          <br/><br/>

                          Our product is designed to give better online experience for the customer and provide technology to the restaurant owners so that they can sell online from their website or custom branded mobile app and connect to their customers. Our cloud based mobile product makes it easier for the business to control the menu, update pictures, manage online orders and engage with customers right from their iPhone or iPad.
                          <br/><br/>


                          From Online Ordering, Custom Mobile App, Picture Menu, Real Time Customer Updates
                          to Mobile CMS, we continuously innovate and develop cloud technology for Restaurants
                          with one goal in mind, give the best online experience.
                      </p>
                      <br/>

                      <h3>Founder</h3>
                      <br/>
                      <p className="lead">
                          Neeraj Bajaj, is the Founder and CEO of FreshBytes.<br/>
                          <br/>

                          He was member of initial team to set up the Virtu Financial Asia Pacific (APAC) office, playing a
                          key role in the profitability of that operation through technical innovations. He relocated back
                          to the United States in two years and took the position of Global Head of the Core API team,
                          managing teams in Los Angeles, New York, Dublin, and Singapore.<br/>
                          <br/>

                          Holding two US patents to his name, Neeraj has authored technical publications,
                          presented at JavaOne, contributed extensively to open source Apache Xerces2 project and
                          acted as the co-specification lead of Java API for XML Processing (JAXP) 1.4.
                      </p>
                      <br/>

                      <h3>Contact Us</h3>
                      <p className="lead">
                          Email us at <a href="mailto:support@freshbytes.io" target="_top">support@freshbytes.io</a> or call us (888)-96-37374
                          <br/>
                          <br/>
                          <br/>
                      </p>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
);

export default About;



// WEBPACK FOOTER //
// src/components/about.js